const galleryId = 34;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1741122272.jpg","sh_1299324343.jpg","sh_25133602.jpg","sh_25133608.jpg","sh_25133605.jpg","sh_126711710.jpg","sh_117892354.jpg","sh_781767679.jpg","sh_124516708.jpg","sh_1512081797.jpg","sh_1512081788.jpg","sh_1279399636.jpg","sh_1279399612.jpg","sh_686157667.jpg","sh_1780338692.jpg","sh_1780338689.jpg","sh_1243858297.jpg","sh_1245192424.jpg","sh_1537207082.jpg","sh_1233977005.jpg","sh_1233977017.jpg","sh_1238221789.jpg","sh_1648436893.jpg","sh_1482166604.jpg","sh_50747512.jpg","sh_50711971.jpg","sh_50747521.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Post'));

group = ["sh_1824108014.jpg","sh_124516717.jpg","sh_129331364.jpg","sh_128457701.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_514663762.jpg","sh_1243858294.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
